import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TableView } from '@components/table/types';

type UseViewIdUrlSyncProps = {
  selectedViewId: string | undefined;
  views: TableView[];
  selectView: (viewId: string) => void;
};

export const useViewIdUrlSync = ({ selectedViewId, views, selectView }: UseViewIdUrlSyncProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewIdFromUrl = searchParams.get('viewId');
  const hasInitializedUrlRef = useRef(false);

  useEffect(() => {
    if (!selectedViewId) return;
    if (!hasInitializedUrlRef.current) {
      hasInitializedUrlRef.current = true;
      return;
    }
    if (viewIdFromUrl !== selectedViewId) {
      setSearchParams(
        (params) => {
          params.set('viewId', selectedViewId);
          return params;
        },
        { replace: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedViewId]);

  useEffect(() => {
    if (!viewIdFromUrl || viewIdFromUrl === selectedViewId) return;
    if (views.find((view) => view.id === viewIdFromUrl)) {
      selectView(viewIdFromUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewIdFromUrl]);

  return viewIdFromUrl;
};
